<!-- No `-mx-4`: this used to pull the toolbar 16 px out of the page gutter, so it sat on a different left edge
     than the page header above it and the list below it. The page gutter belongs to `layout-page-container`
     alone and nothing may cancel part of it (#235). -->
<div class="flex py-4 gap-x-4 pointer-events-none">
  <div class="grid grid-cols-1 gap-x-8 gap-y-8 w-full">
    <form class="bg-gray-100 shadow-sm ring-1 ring-gray-900/5 sm:rounded-xl relative">
      @if (!isCollapsed) {
        <div class="px-3 pt-2 pb-3 pointer-events-auto">
          <ng-content></ng-content>
        </div>
      }
      <div [class.border-t]="!isCollapsed"
           class="pointer-events-auto flex items-center justify-end gap-x-6 border-gray-900/10 py-2 px-3">
        @if (!isCollapsed) {
          <button (click)="clear.emit()"
                  class="text-sm font-semibold leading-6 text-gray-900 px-1.5 rounded-md"
                  type="button">
            {{ clearText }}
          </button>
        } @else if (isCollapsed && hasSearch) {
          <input #search (ngModelChange)="onSearchChange($event)" [ngModel]="searchValue"
                 aria-label="Suchen"
                 class="block w-full rounded-md border-0 py-1.5 px-3 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-theme-primary-700 sm:text-sm sm:leading-6"
                 id="search"
                 name="search"
                 placeholder="Suchen..."
                 type="text">
        }
        @if (hasPermission()) {
          <!-- `[disabled]` only bites while the form is open: collapsed, this same button is the "open the
               form" affordance, and disabling it there would lock the reader out of the fields that explain
               why it is disabled. -->
          <button (click)="onSubmit($event)" [disabled]="submitDisabled && !isCollapsed"
                  class="inline-flex whitespace-nowrap rounded-md bg-theme-primary-700 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-theme-primary-900 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-theme-primary-900 disabled:cursor-not-allowed disabled:opacity-30 disabled:grayscale"
                  type="submit">
            {{ submitText }}
          </button>
        } @else {
          <button (click)="preventDefault($event)" class="hidden" type="submit"></button>
        }
      </div>
      @if (!isCollapsed) {
        <!-- An icon-only button has no text node, so it needs an explicit name: axe reports a nameless button as
             a CRITICAL violation and a screen reader announces it as bare "Schaltfläche". Once the button is
             named, the glyph is decorative. -->
        <button (click)="collapse($event)" type="button" aria-label="Formular schließen"
                class="absolute h-6 w-6 right-3 top-2 text-gray-600 pointer-events-auto">
          <svg aria-hidden="true" viewBox="0 0 256 256" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M208.49 191.51a12 12 0 0 1-17 17L128 145l-63.51 63.49a12 12 0 0 1-17-17L111 128L47.51 64.49a12 12 0 0 1 17-17L128 111l63.51-63.52a12 12 0 0 1 17 17L145 128Z"/>
          </svg>
        </button>
      }
    </form>
  </div>
</div>
